import { Tooltip } from 'antd'
import { filterOption, getFormattedDate, getTatFormatedDate } from 'modules/utilities/utility';
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useRtoReattemptCategory } from './store';
import TextArea from 'antd/es/input/TextArea';
import moment from 'moment';
import { Button, Input, Select, Space, Typography } from 'antd';
import { useCreateTicket } from 'modules/CreateTicket/store';
import secureLocalStorage from 'react-secure-storage';
import { isEmpty } from 'lodash';
const { Text, Title } = Typography;

const RTOReattempt = ({ buttonText, order, customer, name }) => {
    const { rtoReattemptCategoryData } = useRtoReattemptCategory();
    const { createTicket } = useCreateTicket();

    const [modalShow, setModalShow] = React.useState(false);
    const [tatDate, setTatDate] = useState();
    const [payload, setPayload] = useState({});
    const [reamrkOptions, setRemarkOptions] = useState([]);
    const [validation, setValidation] = useState({ description: false });
    const data = {
        'Initiate RTO': {
            //allowedStatus: ['PickedUp', 'picked up', 'InTransit', 'in transit', 'ShipmentDelayed', 'ShipmentHeld', 'ContactCustomerCare', 'OutForDelivery', 'FailedDelivery', 'undelivered', 'NotServiceable'],
            allowedStatus: ['PICKED_UP', 'IN_TRANSIT', 'OUT_FOR_DELIVERY','PickedUp', 'InTransit', 'ShipmentDelayed', 'ShipmentHeld', 'ContactCustomerCare', 'OutForDelivery', 'FailedDelivery', 'NotServiceable'],
            subcategory: 'initiate_rto'
        },
        'Reattempt Request': {
            //allowedStatus: ['OutForDelivery', 'FailedDelivery', 'undelivered', 'NotServiceable'],
            allowedStatus: ['OUT_FOR_DELIVERY', 'OutForDelivery', 'FailedDelivery', 'NotServiceable'],
            subcategory: 'reattempt_request'
        }
    }

    useEffect(() => {
        const customerAddress = _.get(order, ['order_meta', 'shipping_address'], {});
        const address = {
            locality: _.get(customerAddress, 'address1', ''),
            landmark: _.get(customerAddress, 'address2', ''),
            city: _.get(customerAddress, 'city', ''),
            state: _.get(customerAddress, 'province', ''),
            pincode: _.get(customerAddress, 'zip', '')
        }
        const sourceMeta = {
            title: "create_ticket",
            order_display_id: order.order_display_id,
            order_id: order.id,
            order_details: `Customer Name: ${order.order_meta.shipping_address.name} \n\Order ID: ${order?.order_display_id}\n\Order Date: ${getFormattedDate(order?.ordered_date)}\n\Order Amount: ${order?.order_meta.total_price}`,
        }
        const providerMeta = {
            subject: `${order?.order_display_id} | ${order.order_meta.shipping_address?.first_name} : delivery_Issues ---> ${data[name].subcategory}`,
            due_date: null,
            description: ''
        }
        const ticketObject = {
            case_id: customer?.id,
            provider: null,
            current_assignment: null,
            author_id: secureLocalStorage.getItem("id"),
            action_taker: secureLocalStorage.getItem("id"),
            priority: 4,
            category: 'delivery_Issues',
            sub_category: data[name].subcategory,
            is_internal: false,
            products: [],
            total_refund_price: 0.00,
            address: address,
            waba: true,
            remark: '',
            source: 'crm',
            source_meta: sourceMeta,
            provider_meta: providerMeta,
            comment: {
                commented_by: secureLocalStorage.getItem("id"),
                description: '',
                type: 'delivery_Issues'
            },
            due_date: ""
        }
        setPayload(ticketObject);
    }, [order])

    useEffect(() => {
        const tat = getTatFormatedDate(rtoReattemptCategoryData[name]?.tat_limit);
        setTatDate(tat);
        const dueDate = moment(tat).toISOString();
        setPayload(prevPayload => ({ ...prevPayload, due_date: dueDate, current_assignment: rtoReattemptCategoryData[name]?.assignee }));
        if (rtoReattemptCategoryData[name]?.reasons && rtoReattemptCategoryData[name]?.reasons.length > 0) {
            setRemarkOptions(rtoReattemptCategoryData[name]?.reasons?.map(({ label }) => ({ value: label, label: label })));
            setValidation(prevValidation => ({ ...prevValidation, remarks: false }));
        } else {
            setValidation((prevValidation) => {
                const { remarks, ...rest } = prevValidation;
                return rest;
            })
        }
    }, [rtoReattemptCategoryData])

    const onRemarkChange = (value) => {
        setPayload(prevPayload => ({ ...prevPayload, remark: value }));
        setValidation(prevValidation => ({ ...prevValidation, remarks: value ? true : false }));
    }

    const onChangeComment = (value) => {
        setPayload((prevPayload) => {
            return { ...prevPayload, comment: { ...prevPayload.comment, description: value }, provider_meta: { ...prevPayload.provider_meta, description: value } }
        })
        setValidation(prevValidation => ({ ...prevValidation, description: value.length > 0 ? true : false }));
    }

    const getMessage = () => {
        const subStatus = order.sub_status;
        const isReattemptRequest = name === 'Reattempt Request';

        switch (subStatus) {
            case 'Exchange Pickup':
            case 'Exchange In Transit':
            case 'Exchange Delivered': return 'Not Applicable';

            case 'NULL':
            case 'NoStatusExist':
            case 'Awb Registered':
            case 'OrderPlaced':
            case 'OutForPickup':
            case 'rev out for pickup':
            case 'PickupPending':
            case 'LastMilePrePickup':
            case 'PickupFailed': return isReattemptRequest ? 'Disabled as order is yet to be shipped out' : 'Disabled as order is yet to be dispatched';

            case 'PickedUp':
            case 'rev picked up':
            case 'picked up':
            case 'InTransit':
            case 'in transit':
            case 'rev in transit':
            case 'ShipmentDelayed':
            case 'ShipmentHeld':
            case 'CourierPartnerTrackingDataMissing':
            case 'ContactCustomerCare':
            case 'DestinationHubIn':
            case 'OriginCityOut':
            case 'Aged': return 'Inactive as order is in transit';

            case null:
            case 'Delivered':
            case 'Shipment Delivered':
            case 'delivered':
            case 'rev delivered': return 'Inactive as order is delivered';

            case 'Cancelled':
            case 'cancelled': return 'Inactive as order is cancelled';

            case 'Damaged':
            case 'Lost':
            case 'lost/damaged': return isReattemptRequest ? 'Order is lost/Damaged, if prepaid new order is placed, if COD ask Cx to place a new order' : 'Inactive as order is void';

            case 'RTO-Requested':
            case 'RTO-Marked':
            case 'RTO-OutForDelivery':
            case 'RTO-Failed':
            case 'RTO-InTransit':
            case 'RTO-ContactCustomerCare':
            case 'RTO-ShipmentDelay':
            case 'RTO-Delivered':
            case 'RTO Delivered':
            case 'RTO Handover':
            case 'OriginCityIn': return 'Inactive as order is already RTO';

            case 'Expired':
            case 'Ready To Ship': return 'Inactive as order is yet to be dispatched';

            default: return '';
        }
    };

    return (
        <div>
            <Tooltip className='text-center' title={`${name}, ${rtoReattemptCategoryData[name]?.orders?.includes(order.order_display_id) ? `Ticket Already Exist for ${order.order_display_id}` : getMessage()}`}>
                <>
                    {
                        data[name].allowedStatus.includes(order.sub_status) && !rtoReattemptCategoryData[name]?.orders.includes(order.order_display_id) ?
                            <Button style={{ padding: 5 }}
                                onClick={() => {
                                    setModalShow(true)
                                    setValidation({ description: false })

                                }} className='mt-n1 bg-primary text-white rounded-circle d-flex justify-content-center align-items-center shadow'
                            >
                                {buttonText}
                            </Button>
                            :
                            <span className={`mt-n1 bg-primary disabled-action text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow`}>
                                {buttonText}
                            </span>
                    }

                    <Modal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                        size="md"
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter"><Title level={4} className='m-0 p-0'>{name}</Title></Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Title level={5}>
                                Are you sure you want to {name} for this order?
                            </Title>
                            {reamrkOptions?.length > 0 && <Space.Compact block className='my-3'>
                                <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                                    <Text>Remark</Text>
                                </span>
                                <Select
                                    style={{ width: '70%' }}
                                    showSearch
                                    allowClear
                                    placeholder='Select a subcategory'
                                    optionFilterProp='children'
                                    onChange={onRemarkChange}
                                    filterOption={filterOption}
                                    options={reamrkOptions}
                                />
                            </Space.Compact>}
                            <Space.Compact block className='my-3'>
                                <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                                    <Text>{`Due By (${Math.ceil(moment(tatDate).diff(moment(), 'days', true))} days)`}</Text>
                                </span>
                                <Input style={{ width: '70%' }} value={tatDate} />
                            </Space.Compact>
                            <div className='mb-3'>
                                <Text>Description</Text>
                                <TextArea
                                    rows={4}
                                    onPaste={(event) => { onChangeComment(event.clipboardData.getData('Text')) }}
                                    onChange={(event) => { onChangeComment(event.target.value) }}
                                    onKeyUp={(event) => { onChangeComment(event.currentTarget.value) }}
                                />
                            </div>

                        </Modal.Body>
                        <Modal.Footer className='d-flex justify-content-end gap-2 align-items-center'>
                            <Button variant='secondary' onClick={() => setModalShow(false)}>Close</Button>
                            <Button type='primary'
                                disabled={_.size(Object.values(validation).filter(key => !key))}
                                onClick={() => {
                                    createTicket(payload);
                                    setModalShow(false);
                                }}
                            >
                                Submit
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            </Tooltip>
        </div>
    )
}

export default RTOReattempt